import * as Yup from 'yup';

const schema = Yup.object().shape({});

export default schema;
